<template>
  <div class="home-card">
    <div class="home-card-content">
      <div class="carousel-images">
        <img :src="require('@/assets/images/imageCover.png')"
             alt="中医古籍"
             class="cover-image">
        <el-carousel :autoplay="true"
                     :interval="3000"
                     arrow="never"
                     indicator-position="none"
                     ref="carousel"
                     @change="handleCarouselChange">
          <el-carousel-item v-for="item in images"
                            :key="item.id"
                            class="home-card-image-container"
                            @click.native="handleJump(item)">
            <el-image :src="item.imageUrl"
                      alt="中医古籍"
                      class="home-card-image"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="description-card">
        <icon-title-card :title="title"
                         :icon="icon"
                         :content="content"></icon-title-card>
        <data-card></data-card>
      </div>
    </div>
    <div class="indicator">
      <span class="indicator-item"
            v-for="(item, index) in images"
            :class="{active: activeIndex === index}"
            :key="index"
            @click="changeActiveIndex(index)"></span>
    </div>
  </div>
</template>

<script>
import IconTitleCard from './IconTitleCard.vue'
import DataCard from './DataCard.vue'
export default {
  components: { IconTitleCard, DataCard },
  name: 'HomeCard',
  props: {},
  data () {
    return {
      activeIndex: 0,
      title: '数字资源库简介',
      icon: require('@/assets/images/icons/book.png'),
      content:
        '中国中医古籍数字资源库是由中国中医科学院中医药信息研究所/图书馆（全国中医行业古籍保护中心）研发的大型中医古籍图文数据库系统，共收录海内外20余家藏书机构先秦至清末民国的历代医药典籍2500余种。该系统以中医古典目录学为基础，遵循共建共享原则，灵活构建孤本库、官修库等特色专题库，支持单库检索和多库检索，基本检索、高级检索和后控词检索。',
      images: []
    }
  },
  methods: {
    resolveImageUrl (relativeUrl) {
      if (!relativeUrl) return ''
      if (/^https?:\/\//i.test(relativeUrl)) return relativeUrl
      // 相对路径以 /manage_filestorage 开头，通过 manage 代理转发到 manage_backend
      return '/manage' + (relativeUrl.startsWith('/') ? '' : '/') + relativeUrl
    },
    fetchCarouselList () {
      const url = '/manage/carousel/listPublic'
      this.$http.get(url).then(res => {
        const data = (res && res.data && res.data.data) || []
        const list = Array.isArray(data) ? data : []
        this.images = list.map(item => {
          return {
            id: item.id,
            imageUrl: this.resolveImageUrl(item.imageUrl),
            jumpUrl: item.jumpUrl,
            jumpMethod: item.jumpMethod
          }
        })
      }).catch(err => {
        console.log('获取轮播图列表失败', err)
        this.images = []
      })
    },
    handleJump (item) {
      if (!item || !item.jumpUrl) return
      const jumpUrl = item.jumpUrl
      const jumpMethod = item.jumpMethod
      const isArticle = jumpUrl.indexOf('/article/') !== -1 || jumpUrl.indexOf('/article') === 0
      if (jumpMethod === 1) {
        // 新标签页打开
        if (isArticle) {
          // hash 模式路由：需补 '#/' 前缀，否则浏览器直达无 hash URL，router 会回退到默认页
          window.open('/#' + jumpUrl, '_blank')
        } else {
          window.open(jumpUrl, '_blank')
        }
      } else {
        // 当前页跳转
        if (isArticle) {
          // 文章URL：走 SPA 路由
          this.$router.push(jumpUrl)
        } else {
          // 外部URL
          window.location.href = jumpUrl
        }
      }
    },
    changeActiveIndex (index) {
      this.activeIndex = index
      this.$refs.carousel.setActiveItem(index)
    },
    handleCarouselChange (index) {
      this.activeIndex = index
    }
  },
  mounted () {
    this.fetchCarouselList()
  }
}
</script>

<style scoped>
.home-card {
  width: 1160px;
  margin: 0 auto;
  background-color: #fff;
  padding: 20px;
  padding-bottom: 0;
}

.home-card-content {
  display: flex;
  width: 100%;
  height: 418px;
}

.carousel-images {
  position: relative;
}

.cover-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 4;
  pointer-events: none;
}

.home-card >>> .el-carousel {
  position: relative;
  width: 100%;
  height: 100%;
  top: 0%;
  left: 0%;
  z-index: 1;
}

.home-card >>> .el-carousel__container {
  width: 683px;
  height: 418px;
  height: 100%;
}
.indicator {
  width: 100%;
  height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #fff;
}

.indicator-item {
  width: 20px;
  height: 6px;
  border-radius: 3px;
  background-color: #f5eee8;
  margin: 0 5px;
  cursor: pointer;
}

.indicator-item.active {
  background-color: #b47f4d;
}

.description-card {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  margin-left: 20px;
}

.home-card-image-container {
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.home-card-image {
  height: 408px;
  width: 673px;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeCard.vue